<template>
  <div>
    <div class="nav-wrap">
      <div class="center">
        <div class="music-wrap" @click="handleMusic" v-if="false">
          <img :class="playMusic?'running':'paused'" src="@/assets/music/album.png" alt />
          <audio src="@/assets/music/inlove.mp3" hidden ref="audio"></audio>
        </div>
        <div class="blog-nav">
          <div class="item" v-for="(item, index) in navData" :key="index" :class="item.match==activeItem?'active':''" :data-id="item.match" @click="handleNav(item)">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="nav-sub" v-if="showSubNav">
      <div class="center">
        <div class="item" v-for="(item, index) in subData" :key="index" :class="item.match==activeItemSub?'active':''" :data-id="item.match" @click="handleSubNav(item)">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlogNav",
  data() {
    return {
      playMusic: false,
      navData: [
        {
          match: 1,
          name: '推荐'
        },
        {
          match: 2,
          name: '生活'
        },
        {
          match: 3,
          name: '前端',
          sub: [
            {
              match: 1,
              name: 'VueJs'
            },
            {
              match: 2,
              name: 'React'
            }
          ]
        },
        {
          match: 4,
          name: '后端'
        },
        // {
        //   match: 5,
        //   name: '留言'
        // },
        {
          match: 6,
          name: '关于本站'
        }
      ],
      activeItem: 1,
      activeItemSub: 1,
      showSubNav: false,
      subData: null
    };
  },
  methods: {
    handleMusic() {
      /**控制播放 */
      this.$nextTick(() => {
        if (!this.playMusic) {
          this.$refs.audio.play();
        } else {
          this.$refs.audio.pause();
        }
        this.playMusic = !this.playMusic;
        // 监听播放结束
        let that = this;
        this.$refs.audio.addEventListener("ended", function() {
          that.playMusic = !that.playMusic;
        });
      });
    },
    handleNav (val) {
      if (val.match !== this.activeItem) {
        this.activeItem = val.match;
        if (val.hasOwnProperty('sub')) {
          console.log(val.sub);
          this.subData = val.sub;
          this.showSubNav = true;
        } else {
          this.showSubNav = false;
        }
        this.getCondition(val.match);
      }
    },
    handleSubNav (val) {
      if (val.match !== this.activeItem) {
        this.activeItemSub = val.match;
        this.getCondition(val.match);
      }
    },
    getCondition (tagId) {
      this.$emit('click-tag', tagId);
    }
  }
};
</script>

<style lang="less">
@keyframes rotateAni {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.nav-wrap {
  width: 100%;
  height: 3rem;
  background-color: #fff;
  margin: 0 auto;
  .center {
    width: 100%;
    height: auto;
    margin: 0 auto;
    display: -webkit-box;
    .music-wrap {
      width: 3rem;
      height: 3rem;
      margin: 0 1rem;
      img {
        width: 2.5rem;
        height: 2.5rem;
        margin: 0.2rem;
        border-radius: 50%;
        cursor: pointer;
        animation: rotateAni 10s linear infinite;
        &.paused {
          animation-play-state: paused;
        }
      }
    }
    .blog-nav {
      width: auto;
      height: 3rem;
      line-height: 3rem;
      display: flex;
      .item {
        margin: 0 1rem;
        color: #909090;
        &:hover {
          color: #71beff;
          cursor: pointer;
        }
        &.active {
          color: #71beff;
        }
      }
    }
  }
}
.nav-sub {
  width: 100%;
  height: 2.6rem;
  line-height: 2.6rem;
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0 1px 2px 0 #f0f0f0;
  .center {
    width: 60rem;
    height: auto;
    margin: 0 auto;
    display: flex;
    .item {
      margin: 0 1rem;
      color: #909090;
      font-size: 0.92rem;
      text-align: center;
      &:hover {
        color: #71beff;
        cursor: pointer;
      }
      &.active {
        color: #71beff;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .nav-wrap {
    .center {
      overflow-x: auto;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .blog-nav {
        .item {
          min-width: 2rem;
        }
      }
    }
  }
  .nav-sub {
    .center {
      width: 100%;
      overflow-x: auto;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .item {
        min-width: 2rem;
      }
    }
  }
}
</style>